import { render } from "./ModalAddNote.vue?vue&type=template&id=30c47c44"
import script from "./ModalAddNote.vue?vue&type=script&lang=js"
export * from "./ModalAddNote.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__